/* eslint-disable */
(function(w, d, t, u, n, a, m) { w.MauticTrackingObject = n
  w[n] = w[n] || function() { (w[n].q = w[n].q || []).push(arguments) }, a = d.createElement(t),
    m = d.getElementsByTagName(t)[0]; a.async = 1; a.src = u; m.parentNode.insertBefore(a, m)
})(window, document, 'script', process.env.VUE_APP_API_MARKETING_URL + '/mtc.js', 'mt')
mt('send', 'pageview')
